export { isAlreadyPrefetched };
export { markAsAlreadyPrefetched };
import { getUrlPathname } from '../utils';
const linkAlreadyPrefetched = new Map();
function isAlreadyPrefetched(url) {
    const prefetchUrl = getPrefetchUrl(url);
    return linkAlreadyPrefetched.has(prefetchUrl);
}
function markAsAlreadyPrefetched(url) {
    const prefetchUrl = getPrefetchUrl(url);
    linkAlreadyPrefetched.set(prefetchUrl, true);
}
function getPrefetchUrl(url) {
    return getUrlPathname(url);
}
